// extracted by mini-css-extract-plugin
module.exports = {"navbar":"navbar_navbar__2wbBl"};